import { withTranslation } from 'react-i18next';
import { Route, Routes } from 'react-router-dom';
import GHGOverview from './GHGOverview';
import NewGHGOverview from './NewGHGOverview';
import GHGEmissionDatasetContainer from '../../SuperAdmin/GHGDatasets/GHGEmissionDatasetContainer';
import EmissionDatasetVersionManagement from '../../SuperAdmin/GHGDatasets/EmissionDatasetVersionManagement';


const GHGEmissionsContainer = ({ t }) => {
	return (
		<div>
			<Routes>
				{/* <Route path="overview" element={<GHGOverview />} /> */}
				<Route path="overview" element={<NewGHGOverview />} />
				<Route path="new_overview" element={<NewGHGOverview />} />
				<Route path="/datasets" element={<GHGEmissionDatasetContainer />} />
				<Route path="/datasets/:datasetName/versions" element={<EmissionDatasetVersionManagement />} />
			</Routes>
		</div>
	);
};
export default withTranslation()(GHGEmissionsContainer);